import script from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=27833365&lang=scss"

const __exports__ = script;

export default __exports__